// Global
export const PUSH_NOTIFICATION = "PUSH_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const CLOSE_COOKIES_NOTIFICATION = "CLOSE_COOKIES_NOTIFICATION";
export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";

// Home
export const SET_HOME_ACTIVE = "SET_HOME_ACTIVE";

// Videos
export const SET_VIDEOS = "SET_VIDEOS";
export const SET_TAGS = "SET_TAGS";
export const TOGGLE_TAG_SELECTION = "TOGGLE_TAG_SELECTION";
export const SELECT_TAG = "SELECT_TAG";
export const CLEAR_SELECTED_TAGS = "CLEAR_SELECTED_TAGS";
export const SWITCH_DARK_MODE = "SWITCH_DARK_MODE";
export const SET_VIDEOS_QUERY = "SET_VIDEOS_QUERY";
export const CLEAR_VIDEOS_QUERY = "CLEAR_VIDEOS_QUERY";

// Video
export const SET_VIDEO = "SET_VIDEO";
export const SET_VIDEO_SOURCES = "SET_VIDEO_SOURCES";
export const SET_VIDEO_SUGGESTIONS = "SET_VIDEO_SUGGESTIONS";

// Meta
export const SET_META_INFO = "SET_META_INFO";
export const CLEAR_SENSITIVE_META_INFO = "CLEAR_SENSITIVE_META_INFO";

// Security
export const SET_TOKEN = "SET_TOKEN";
export const CLEAR_TOKEN = "CLEAR_TOKEN";

// Content
export const SET_TEMPLATE = "SET_TEMPLATE";

// Messages
export const SET_MESSAGES = "SET_MESSAGES";
export const SET_CURRENT_MESSAGE = "SET_CURRENT_MESSAGE";
export const CLEAR_CURRENT_MESSAGE = "CLEAR_CURRENT_MESSAGE";
export const SET_FAVORED_MESSAGES = "SET_FAVORED_MESSAGES";

// Program
export const SET_BLOCKS = "SET_BLOCKS";
export const SET_PROGRAM = "SET_PROGRAM";

// Statistics
export const SET_GLOBAL_STATISTICS = "SET_GLOBAL_STATISTICS";
export const SET_VIDEO_STATISTICS = "SET_VIDEO_STATISTICS";
export const SET_VIDEOS_STATISTICS = "SET_VIDEOS_STATISTICS";
export const SET_MESSAGES_STATISTICS = "SET_MESSAGES_STATISTICS";
export const SET_VIDEOS_RANK = "SET_VIDEOS_RANK";
export const SET_MESSAGES_RANK = "SET_MESSAGES_RANK";
export const SET_USERS_RANK = "SET_USERS_RANK";
export const SET_CUSTOM_RANK = "SET_CUSTOM_RANK";
export const SET_EVENTS = "SET_EVENTS";

// Users
export const SET_USERS = "SET_USERS";
export const SET_AUTHORITIES = "SET_AUTHORITIES";

// Diagnostics
export const SET_AVAILABLE_METRICS = "SET_AVAILABLE_METRICS";
export const SET_METRICS = "SET_METRICS";
export const SET_DIAGNOSTICS = "SET_DIAGNOSTICS";

// mutation types will be defined here
